module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/work/project-info.component.scss
// module id = ./src/app/work/project-info.component.scss
// module chunks = main